import { motion } from "framer-motion";
import { EASE_EXPO } from "@/lib/motion";

/**
 * Editorial Word Stagger Text Reveal.
 * Wraps words in overflow-hidden containers for a clip-path typography assembly.
 */
export function TextReveal({
  children,
  className = "",
  delay = 0,
  stagger = 0.05,
  as: Component = "h2",
  ...props
}) {
  if (typeof children !== "string") {
    return <Component className={className} {...props}>{children}</Component>;
  }

  const words = children.split(" ");

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: stagger,
        delayChildren: delay,
      },
    },
  };

  const wordVariants = {
    hidden: { y: "115%", opacity: 0 },
    visible: {
      y: "0%",
      opacity: 1,
      transition: {
        duration: 0.45,
        ease: EASE_EXPO,
      },
    },
  };

  return (
    <Component className={className} {...props}>
      <motion.span
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-40px" }}
        className="inline-flex flex-wrap gap-x-[0.24em] gap-y-[0.05em] leading-[0.95]"
      >
        {words.map((word, index) => (
          <span key={index} className="inline-block overflow-hidden py-[0.06em]">
            <motion.span variants={wordVariants} className="inline-block">
              {word}
            </motion.span>
          </span>
        ))}
      </motion.span>
    </Component>
  );
}

export default TextReveal;
